import axios from "axios";
import { useEffect, useState } from "react";
import Swal from 'sweetalert2'

function AdminPanelDelete(){
  
  const [project, setProjects] = useState([]);
  const [render, setRerender] = useState(true);
  const url = 'https://reactportfolio-api.vercel.app/';

  useEffect(() => {
    if(render){
      async function projectFetch(){
        try{
          await fetch(url+'get/projects')
          .then((res)=>res.json())
          .then((json)=>setProjects(json));
        } catch (err) {
          console.log(`Internal Server Error => ${err}`)
        }
      }
      projectFetch();
    }
    setRerender(false)
  }, [render]);

  function handleDelete(e){
    Swal.fire({
      title: `Are You Sure To Delete ${e.target.title} ?`,
      showCancelButton: true,
    }).then(async (data)=>{
      if(data.isConfirmed){
        try{
          const projectId = e.target.id;
          await axios.delete(`${url}del/${projectId}`)
          .then(()=>setRerender(true));
          document.getElementById('messSend').textContent = 'Data Sent Successfully';
        } catch (err) {
          document.getElementById('messSend').textContent = 'Data NOT Sent Successfully!'+err;
        }
      }
    })
  }

  return(
    <div className="admin">
      <h3>Delete Projects:</h3>
      <p id="messSend"></p>
      <div className="delete container">
      {project.map((p) => {  
      return(
        <li key={p._id}>
          <div className="image">
            <img src={p.projectImage} />
          </div>
          <p>{p.projectName}: <button id={p._id} title={p.projectName} onClick={handleDelete}>delete</button></p>
        </li>
        )})}
      </div>
    </div>
    )
}
export default AdminPanelDelete;